import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CashVouchersComponent } from './cash-vouchers/cash-vouchers.component';
import { ExternalVouchersComponent } from './external-vouchers/external-vouchers.component';

const routes: Routes = [
  {
    path: 'cash-vouchers',
    component: CashVouchersComponent
  },
  {
    path: 'external-vouchers',
    component: ExternalVouchersComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VouchersRoutingModule {}